<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-30">
      <el-container>
        <el-aside width="330px">
          <sidebar></sidebar>
        </el-aside>
        <el-main>
          <companySide
            v-if="type"
            :isButton="isButton"
            @release="gorelease()"
          ></companySide>
          <headSide v-else @release="gorelease()"></headSide>
          <!--详情-->
          <div class="mt-30">
            <contTitle
              :obj="obj"
              :contTitle="contTitle"
               @onBacker="Backer()"
            ></contTitle>
            <material :measObj="measObj"></material>
          </div>
          <!--浏览用户-->
          <div v-if="nextTour" class="mt-30">
            <contTitle :obj="obj1" :contTitle="contTitle2"></contTitle>
            <pictureLeftList :list="nubmerList" v-if="isNumber" class="mt-20"></pictureLeftList>
            <Pagination
              v-show="totals > 0"
              :total="totals"
              :page.sync="dataQuery.curPage"
              :limit.sync="dataQuery.limit"
              @pageChange="pageNumber"
            ></Pagination>
          </div>

          <div style="margin-top: 20%">
            <notList :notCode="notCode"></notList>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
import {
  getDetail,
  myBrowseList,
} from "@/api/coment";
import sidebar from "../../common/sidebar";
import companySide from "../../common/companySide";
import headSide from "../../common/headSide";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import contTitle from "../../common/contTitle";
import pictureLeftList from "../../components/pictureLeftList";
import material from "../../components/material";
import notList from "../../common/notList";
export default {
  components: {
    sidebar,
    headSide,
    companySide,
    commBanner,
    titleHead,
    contTitle,
    pictureLeftList,
    notList,
    material
  },
  data() {
    return {
      contTitle: "添加资料",
      buttonText: "发布资料",
      contTitle2: "浏览用户",
      headTitle: "我的资料",
      obj: {
        title: "我的资料",
        isShow: false,
        backer: false,
        roleType: "",
        personalType: 9
      },
      obj1: {
        title: "我的资料",
        isShow: false,
        roleType: "",
        personalType: 9,
      },

      labelPosition: "left",
      fileList: [],
      measObj: {},
      dataQuery: {
        curPage:1,
        limit:4,
        goodsType: 1,
        goodsId:''
      },
      nubmerList: [], //浏览用户
      type: false,
      isButton: false,
      nextTour:false,
      notCode:false,
      goodsId:'',
      isNumber:false
    };
  },
  created() {
    let type = this.$store.state.user.userInfo.type;
    let id = this.$route.query.id;
    if(id){
       this.obj.backer = true;
       this.getInfo(id);
       this.dataQuery.goodsId = id;
       this.getNubmer();
    }
    this.obj.roleType = type;
    if(type == 3){
      this.type = true;
      this.headTitle = "企业资料";
      this.obj.title = "企业资料";
    }
  },
  methods: {
    //发布
    gorelease() {
      this.$router.push("/demand");
    },
    //返回
    Backer(){
      this.$router.push('/demand')
    },
    //查看详情
    getInfo(id) {
      this.contTitle = "资料详情";
      let params = { id:id };
      getDetail(params)
        .then((res) => {
          if (res.code == 0) {
            this.measObj = res.data;
          }
        }).catch((err) => {});
    },
    //浏览用户人数
    getNubmer() {
      myBrowseList(this.dataQuery)
        .then((res) => {
          if(res.code == 0){
            this.nubmerList = res.page.list;
            this.totals = res.page.totalCount;
            res.page.list.length>0?this.nextTour = true:this.nextTour = false;
            this.isNumber = true;
          }
        })
        .catch((err) => {});
    },
     //资料浏览用户分页
    pageNumber(item){
      this.dataQuery["curPage"] = item.page;
      this.dataQuery["limit"] = item.limit;
      this.getNubmer();
    }
  },
};
</script>
<style scoped>
.dn {
  display: none;
}
.mt-40 {
  margin-top: 40px;
}
.contents {
  width: 100%;
  height: 110px;
  border: 1px solid #dedede;
  margin-bottom: 20px;
  transition: all 0.5s;
}
.contents:hover {
  box-shadow: 0 0 20px #ddd;
}
.contents_left {
  margin-left: 15px;
}
.garden_box {
  width: 62px;
  height: 62px;
  background: #ff7302;
  border: 1px solid #eeeeee;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.garden_box span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
}
.garden_box span:nth-child(1) {
  /* margin-left: 11px; */
}
.contents_left p span {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.contents_middle {
  text-align: left;
  /* margin-left: 10px; */
  display: flex;
  flex-direction: column;
  width: 58%;
  /* border: 1px solid red; */
}
.contents_middle_title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: break-word;
}
.mecer_font {
  display: flex;
  justify-content: flex-start;
}
.mecer_font p {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-top: 15px;
}
/* .contents_middle p:nth-child(2){   
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-top: 15px;
} */
.contents_right {
  text-align: right;
  margin-right: 20px;
}
.contents_right p:nth-child(1) {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.contents_right p:nth-child(2) {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-top: 15px;
}
.contents_right p:nth-child(2):hover {
  cursor: pointer;
}
.contents_right p:nth-child(2) span:hover{
  color: #FF7302;
}
.contents_right p span:last-child {
  color: #343434;
}
.ml-12 {
  margin-left: 12px;
}
.ml-15 {
  margin-left: 15px;
}
.ml-20 {
  margin-left: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.tel {
  text-align: left;
}
.red {
  color: #ff7171;
}

.el-form-item {
  text-align: left;
}
.info_form >>> .el-input__inner {
  height: 50px;
}
.info_form >>> .el-select .el-input__inner {
  height: 50px;
}

.box_textarea >>> .el-textarea__inner {
  /* width: 300px; */
  height: 168px;
}

/deep/.file {
  position: relative;
}
/deep/ .upload-demo {
  position: absolute;
  top: 0;
  right: 0;
}
.busin_btn {
  width: 103px;
  height: 50px;
  background: #e5e5e5;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  border: none;
}
.info_form >>> .refer {
  width: 114px;
  height: 40px;
  background: #3bbb35;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin-top: 30px;
}
.text_center {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.el-pagination {
  margin-top: 40px;
}
.bater_tetx {
  height: 30px;
  text-align: left;
  margin-left: 15px;
  font-size: 14px;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/view/coment/meansDetail.vue